import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import AdminDevices from "./AdminTools/AdminDevices";
import AdminLogin from "./AdminTools/AdminLogin";
import Companies from "./AdminTools/Companies";
import ControlPanel from "./AdminTools/ControlPanel";
import NewCompany from "./AdminTools/NewCompany";
import NewDevice from "./AdminTools/NewDevice";
import NewUser from "./AdminTools/NewUser";
import User from "./AdminTools/User";
import Users from "./AdminTools/Users";
import "./App.css";
import PopupSnackbar from "./Components/PopupSnackbar";
import AdminRoute from "./Utils/AdminRoute";
import { getToken } from "./Utils/Common";
import PrivateRoute from "./Utils/PrivateRoute";
import PublicRoute from "./Utils/PublicRoute";
import { useStyles } from "./Utils/Styles";
import Alerts from "./Views/Alerts";
import AlertView from "./Views/Alerts/Alert";
import ChangePassword from "./Views/ChangePassword";
import Dashboard from "./Views/Dashboard";
import DeviceDetails from "./Views/DeviceDetails";
import Devices from "./Views/Devices";
import Login from "./Views/Login";
import Monitoring from "./Views/Monitoring";
import Report from "./Views/Report";
import SendPasswordReset from "./Views/SendPasswordReset";
import Settings from "./Views/Settings";
import TransportDetails from "./Views/TransportDetails";
import Transports from "./Views/Transports";

export default function App() {
  const classes = useStyles();
  return (
    <React.Fragment>
      <PopupSnackbar />
      <div className={classes.root}></div>
      <Switch>
        <Route exact path="/">
          {getToken() ? (
            <Redirect to={{ pathname: "/dashboard" }} />
          ) : (
            <Redirect to={{ pathname: "/login" }} />
          )}
        </Route>

        <AdminRoute path="/cpanel/companies/new" component={NewCompany} />
        <AdminRoute path="/cpanel/companies" component={Companies} />

        <AdminRoute path="/cpanel/users/new" component={NewUser} />
        <AdminRoute path="/cpanel/users/:user_id" component={User} />
        <AdminRoute path="/cpanel/users" component={Users} />

        <AdminRoute path="/cpanel/devices/new" component={NewDevice} />

        <AdminRoute
          path="/cpanel/devices/:device_id"
          component={DeviceDetails}
        />
        <AdminRoute path="/cpanel/devices" component={AdminDevices} />

        <AdminRoute path="/cpanel" component={ControlPanel} />

        {/* Normal routes */}
        <PrivateRoute path="/dashboard" component={Dashboard} />
        <PrivateRoute path="/devices/:device_id" component={DeviceDetails} />
        <PrivateRoute path="/devices" component={Devices} />
        <PrivateRoute path="/monitoring/:select_date" component={Monitoring} />
        <PrivateRoute path="/monitoring" component={Monitoring} />
        {/*<PrivateRoute
              path="/report/:transport_id/:graph"
              component={Report}
            />*/}
        <PrivateRoute
          path="/report/transport/:transport_id"
          component={Report}
        />
        <PrivateRoute
          path="/report/continuous/:date_start/:date_end"
          component={Report}
        />
        <PrivateRoute path="/alerts/:alert_id" component={AlertView} />
        <PrivateRoute path="/alerts" component={Alerts} />
        <PrivateRoute
          path="/transports/:transport_id"
          component={TransportDetails}
        />
        <PrivateRoute path="/transports" component={Transports} />
        <PrivateRoute path="/settings" component={Settings} />

        {/* Public routes*/}
        <PublicRoute path="/login" component={Login} />
        <PublicRoute path="/admin_login" component={AdminLogin} />
        <PublicRoute path="/reset_password/:token" component={ChangePassword} />
        <PublicRoute path="/reset_password" component={SendPasswordReset} />
      </Switch>
    </React.Fragment>
  );
}
